import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { isDevServer } from 'Utils'
import useMobileDetect from 'Hooks/useMobileDetect'
import { _GoogleIcon, _GoogleBtn, _GSIButtonContainer, _ErrorMsg } from 'Components/GoogleSSO/styles.js'

const GoogleSSOApp = ({ userGoogleLogin, googleAnalyticsEvent, closeModal, loginPage, text = 'Sign In' }) => {
  const [googleClientError, setGoogleClientError] = useState('')
  const { isIos } = useMobileDetect()
  const appGoogleLoginCallback = (response) => {
    setGoogleClientError(`response: ${JSON.stringify(response)}`)
    const { idToken } = response
    if(idToken) {
      userGoogleLogin({ crediential: idToken, loginPage, platform: isIos ? 'ios' : 'android' })
      closeModal()
    } else {
      return setGoogleClientError(
        `goNativeGoogleLoginCallback failed to retrieve token: ${JSON.stringify(response)}`,
      )
    }
  }
  return (
    <_GSIButtonContainer aria-describedby="Google Sign In Button">
      <_GoogleBtn
        onClick={() => {
          try {
            if(
              typeof window !== 'undefined' &&
              window.gonative &&
              window.gonative.socialLogin
            ) {
              window.gonative.socialLogin.google.login({ callback: appGoogleLoginCallback })
              googleAnalyticsEvent({
                category: 'GoogleSSO',
                action: '[App SignIn Btn Click]',
              })
            } else {
              setGoogleClientError(
                'GoNative API is not available. Make sure you are using the app, not a browser.',
              )
            }
            return true
          } catch(error) {
            setGoogleClientError(error)
          }
        }}
      >
        <_GoogleIcon name="#icon-sso" width={20} height={20} />
        <p>{text} with Google</p>
      </_GoogleBtn>
      {isDevServer() && googleClientError && <_ErrorMsg>{googleClientError}</_ErrorMsg>}
    </_GSIButtonContainer>
  )
}

GoogleSSOApp.propTypes = {
  userGoogleLogin: PropTypes.func,
  googleAnalyticsEvent: PropTypes.func,
  closeModal: PropTypes.func,
  loginPage: PropTypes.bool,
  text: PropTypes.string,
}

export default GoogleSSOApp
